"use strict";
/* globals module */
/**
 * @module calendarEventRsvpInvitationTypeClient
 * @description  CalendarEventRsvpInvitationTypeClient provides an easy way to consume CalendarEventRsvpInvitationType REST API end-points. In order to obtain needed routes `calendarEventRsvpInvitationTypeClient` uses `calendarEventRsvpInvitationTypeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CalendarEventRsvpInvitationTypeClient = /** @class */ (function () {
    function CalendarEventRsvpInvitationTypeClient(calendarEventRsvpInvitationTypeBatchClient, calendarEventRsvpInvitationTypeRoute, apiClient) {
        this.calendarEventRsvpInvitationTypeBatchClient = calendarEventRsvpInvitationTypeBatchClient;
        this.calendarEventRsvpInvitationTypeRoute = calendarEventRsvpInvitationTypeRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpInvitationTypeClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpInvitationTypeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventRsvpInvitationTypeClient.prototype, "batch", {
        get: function () {
            return this.calendarEventRsvpInvitationTypeBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventRsvpAttendeeInvitationType resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventRsvpInvitationTypeClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventRsvpAttendeeInvitationType resource.
     * @method
     * @param id CalendarEventRsvpAttendeeInvitationType id which uniquely identifies CalendarEventRsvpAttendeeInvitationType resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventRsvpInvitationTypeClient.get(id)
                    .then(function (data) {
                        // perform success action here
                    },
                    function (response, status, headers, config) {
                        // perform error handling here
                    });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvpAttendeeInvitationType action has been performed; this action creates a new CalendarEventRsvpAttendeeInvitationType resource.
     * @method
     * @param data A CalendarEventRsvpAttendeeInvitationType object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvpAttendeeInvitationType action has been performed.
     * @example calendarEventRsvpInvitationTypeClient.create({
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvpAttendeeInvitationType action has been performed; this action updates a CalendarEventRsvpAttendeeInvitationType resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpInvitationTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvpAttendeeInvitationType);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventRsvpAttendeeInvitationType object used to update specified CalendarEventRsvpAttendeeInvitationType resource.
     * @returns A promise that is resolved once the update CalendarEventRsvpAttendeeInvitationType action has been performed.
     * @example calendarEventRsvpAttendeeInvitationType is a resource previously fetched using get action.
                calendarEventRsvpAttendeeInvitationType.name = '<name>';
                calendarEventRsvpInvitationTypeClient.update(calendarEventRsvpAttendeeInvitationType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventRsvpAttendeeInvitationType resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpAttendeeInvitationTyleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvpAttendeeInvitationType);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventRsvpAttendeeInvitationType object used to delete specified CalendarEventRsvpAttendeeInvitationType resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpAttendeeInvitationType is a resource previously fetched using get action.
                calendarEventRsvpInvitationType.remove(calendarEventRsvpAttendeeInvitationType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventRsvpAttendeeInvitationType resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventRsvpInvitationTypeClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    CalendarEventRsvpInvitationTypeClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpInvitationTypeBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRsvpInvitationTypeRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpInvitationTypeBatchClient !== "undefined" && __1.CalendarEventRsvpInvitationTypeBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventRsvpInvitationTypeRoute !== "undefined" && __1.CalendarEventRsvpInvitationTypeRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventRsvpInvitationTypeClient);
    return CalendarEventRsvpInvitationTypeClient;
}());
exports.CalendarEventRsvpInvitationTypeClient = CalendarEventRsvpInvitationTypeClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
